/**
 * Centralized route titles configuration
 * Maps route paths to page titles
 * Supports pattern matching for dynamic routes (e.g., /connext-profile/:userId)
 */

const routeTitles = {
  // Public routes
  "/": "Home | QL One",
  "/logout": "Logout | QL One",
  "/auto/login": "Auto Login | QL One",
  "/gap-kyc": "GAP KYC | QL One",
  "/mba-kyc": "MBA KYC | QL One",
  "/video-player": "Video Player | QL One",
  "/help-center": "Help Center | QL One",
  "/help-content": "Help Content | QL One",
  "/delete-page": "Delete Page | QL One",
  "/profile/guest-ticket/:id": "Guest Ticket | QL One",
  "/ticket/:id": "Ticket | QL One",
  "/proficorn-feedback/:userId/:count": "Proficorn Feedback | QL One",

  // Main protected routes
  "/home": "Home | QL One",
  "/profile": "Profile | QL One",
  "/connext": "Connext | QL One",
  "/proficorn-networking": "Proficorn Networking | QL One",
  "/connext-profile/:userId": "Profile | QL One",

  // Growth routes
  "/growth": "Growth | QL One",
  "/growth/program-Overview": "Program Overview | QL One",
  "/growth/started-program": "Started Program | QL One",
  "/growth/resourceview": "Resource View | QL One",
  "/growth/allresource": "All Resources | QL One",
  "/growth/viewpdf": "View PDF | QL One",

  // Bazaar Buyer routes
  "/bazaar": "Bazaar | QL One",
  "/bazaar/buyer-Service": "Services | QL One",
  "/bazaar/buyer-seller": "Sellers | QL One",
  "/bazaar/buyer-appointment": "Appointments | QL One",
  "/bazaar/buyer-orders": "Orders | QL One",
  "/bazaar/service-details/:id": "Service Details | QL One",

  // Bazaar Seller routes
  "/seller": "Seller Dashboard | QL One",
  "/seller/service": "My Services | QL One",
  "/seller/addservice": "Add Service | QL One",
  "/seller/appointment": "Appointments | QL One",
  "/seller/orders": "Orders | QL One",

  // Chat & Notifications
  "/chat": "Chat | QL One",
  "/notification": "Notifications | QL One",

  // MBA routes
  "/mymba/home": "MBA Home | QL One",
  "/mymba/community": "MBA Community | QL One",
  "/mymba/sessions": "MBA Sessions | QL One",
  "/mymba/mydocs": "My Docs | QL One",

  // Event routes
  "/event": "Events | QL One",
  "/event/gap": "GAP Program | QL One",
  "/event/mba": "MBA Program | QL One",
  "/event-details": "Event Details | QL One",
  "/mmp-event": "MMP Event | QL One",
  "/bma-event": "BMA Event | QL One",
  "/oli-event": "OLI Event | QL One",
  "/tpp-event": "TTP Program | QL One",
  "/pmp-event": "PMP Program | QL One",
  "/hma-event": "HMA Program | QL One",
  "/mma-event": "MMA Event | QL One",
  "/mmp-event/mba": "MBA Program | QL One",
  "/sap-event": "SAP Program | QL One",
  "/lmg-event": "LMG Event | QL One",
  "/event-zoom-meeting": "Zoom Meeting | QL One",
  "/temp/yourinfo": "Your Info | QL One",
  "/mmp_mba-event": "MMP MBA Event | QL One",

  // Other routes
  "/customers-documents": "Documents | QL One",
  "/bic/kyc": "KYC form | QL One",
};

/**
 * Get page title for a given pathname
 * Handles exact matches and dynamic route patterns
 * @param {string} pathname - Current pathname
 * @returns {string} Page title
 */
export const getPageTitle = (pathname) => {
  // Try exact match first
  if (routeTitles[pathname]) {
    return routeTitles[pathname];
  }

  // Try pattern matching for dynamic routes
  for (const [pattern, title] of Object.entries(routeTitles)) {
    // Convert route pattern to regex (e.g., /connext-profile/:userId -> /connext-profile/[^/]+)
    const regexPattern = pattern.replace(/:[^/]+/g, "[^/]+");
    const regex = new RegExp(`^${regexPattern}$`);
    
    if (regex.test(pathname)) {
      return title;
    }
  }

  // Default fallback
  return "QL One";
};

export default routeTitles;
